import React from "react";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";

export const Loader = ({ show = true, fullScreen = false }) => {
  const { t } = useTranslation();
  
  if (!show) return null;
  
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: fullScreen ? "100vh" : "60vh",
        width: "100%",
        gap: "16px",
      }}
    >
      <Spin size="large" />
      <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "14px" }}>
        {t("common.loading")}
      </div>
    </div>
  );
};
